import styled from "@emotion/styled/macro";

export const CustomEdgeLabel = styled.div`
    background: ${({ isPopoverOpen, isTempEdge }) => isPopoverOpen || isTempEdge ? '#333' : '#747982'};
    color: #fff;
    border-radius: 14px;
    padding: 4px 12px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    min-width: 40px;
    user-select: none;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    &:hover {
        ${({ isPopoverOpen, isTempEdge }) => !(isPopoverOpen || isTempEdge) && `
            background: #585D66;
        `}
    }
`;